import { defineMessages } from 'react-intl';

// ─── Auth ────────────────────────────────────────────────────────────────────

const authRouteMessages = defineMessages({
  joinOrSignInCustomDocumentTitle: {
    defaultMessage: 'Order | Sign in or create an account | sweetgreen',
    description: 'Routes | Join or Sign In | Custom Document Title',
  },
});

// ─── Modals ──────────────────────────────────────────────────────────────────

const modalRouteMessages = defineMessages({
  bagCustomDocumentTitle: {
    defaultMessage: 'Order | Cart | sweetgreen',
    description: 'Routes | Bag | Custom Document Title',
  },
  orderStatusCustomDocumentTitle: {
    defaultMessage: 'Order Status | sweetgreen',
    description: 'Routes | Order Status | Custom Document Title',
  },
  personalDataTitle: {
    defaultMessage: 'Sweetgreen Data Subject Requests',
    description: 'Routes | Personal Data | Title',
  },
  addGiftCardTitle: {
    defaultMessage: 'Add gift card',
    description: 'Routes | Add Gift Card | Title',
  },
  redeemGiftCardTitle: {
    defaultMessage: 'Redeem gift card',
    description: 'Routes | Redeem Gift Card | Title',
  },
  forgotToScanCustomDocumentTitle: {
    defaultMessage: 'Forgot To Scan | sweetgreen',
    description: 'Routes | Forgot To Scan | Custom Document Title',
  },
  groupOrderSetupTitle: {
    defaultMessage: 'Group Ordering',
    description: 'Routes | Group Order Setup | Title',
  },
  groupOrderLocationSearchTitle: {
    defaultMessage: 'Choose location',
    description: 'Routes | Group Order Location Search | Title',
  },
  receiptCustomDocumentTitle: {
    defaultMessage: 'Receipt | sweetgreen',
    description: 'Routes | Receipt | Custom Document Title',
  },
  receiptClaimCustomDocumentTitle: {
    defaultMessage: 'Claim Receipt | sweetgreen',
    description: 'Routes | Claim Receipt | Custom Document Title',
  },
  creditAddTitle: {
    defaultMessage: 'Enter promo code',
    description: 'Routes | Credit Add | Title',
  },
  rateOrderTitle: {
    defaultMessage: 'Rate your order',
    description: 'Routes | Rate Order | Title',
  },
  hsaFsaTitle: {
    defaultMessage: 'HSA / FSA',
    description: 'Routes | Account HSA / FSA | Title',
  },
  hsaFsaCustomDocumentTitle: {
    defaultMessage: 'HSA / FSA | sweetgreen',
    description: 'Routes | Account HSA / FSA | Custom Document Title',
  },
});

// ─── Home Tab ────────────────────────────────────────────────────────────────

const homeTabRouteMessages = defineMessages({
  homeTitle: {
    defaultMessage: 'Home',
    description: 'Routes | Home | Title',
  },
  homeCustomDocumentTitle: {
    defaultMessage: 'Home | sweetgreen',
    description: 'Routes | Home | Custom Document Title',
  },
});

// ─── Menu Tab ────────────────────────────────────────────────────────────────

const menuTabRouteMessages = defineMessages({
  locationsTitle: {
    defaultMessage: 'Menu',
    description: 'Routes | Menu | Title',
  },
  locationsCustomDocumentTitle: {
    defaultMessage: 'Locations | sweetgreen',
    description: 'Routes | Menu | Custom Document Title',
  },
});

// ─── Loyalty Tab ─────────────────────────────────────────────────────────────

const loyaltyTabRouteMessages = defineMessages({
  loyaltyTitle: {
    defaultMessage: 'Rewards',
    description: 'Routes | Loyalty | Title',
  },
  loyaltyCustomDocumentTitle: {
    defaultMessage: 'Loyalty Home | sweetgreen',
    description: 'Routes | Loyalty | Custom Document Title',
  },
});

// ─── Reorder Tab ─────────────────────────────────────────────────────────────

const reorderTabRouteMessages = defineMessages({
  reorderTitle: {
    defaultMessage: 'Reorder',
    description: 'Routes | Reorder | Title',
  },
  reorderCustomDocumentTitle: {
    defaultMessage: 'Reorder | sweetgreen',
    description: 'Routes | Reorder | Custom Document Title',
  },
});

// ─── Account Tab ─────────────────────────────────────────────────────────────

const accountTabRouteMessages = defineMessages({
  accountMenuCustomDocumentTitle: {
    defaultMessage: 'Account | sweetgreen',
    description: 'Routes | Account Menu | Custom Document Title',
  },
  profileTitle: {
    defaultMessage: 'Account info',
    description: 'Routes | Account Profile | Title',
  },
  profileCustomDocumentTitle: {
    defaultMessage: 'Account Info | sweetgreen',
    description: 'Routes | Account Profile | Custom Document Title',
  },
  paymentsTitle: {
    defaultMessage: 'Payments',
    description: 'Routes | Account Payments | Title',
  },
  paymentsCustomDocumentTitle: {
    defaultMessage: 'Payments | sweetgreen',
    description: 'Routes | Account Payments | Custom Document Title',
  },
  creditAndPromoCodesTitle: {
    defaultMessage: 'Credit & promo codes',
    description: 'Routes | Account Credit & Promo Codes | Title',
  },
  creditAndPromoCodesCustomDocumentTitle: {
    defaultMessage: 'Credit & Promo Codes | sweetgreen',
    description: 'Routes | Account Credit & Promo Codes | Custom Document Title',
  },
  giftCardsTitle: {
    defaultMessage: 'Gift card',
    description: 'Routes | Account Gift Cards | Title',
  },
  accountGiftCardsCustomDocumentTitle: {
    defaultMessage: 'Gift Cards | sweetgreen',
    description: 'Routes | Account Gift Cards | Custom Document Title',
  },
  addressesTitle: {
    defaultMessage: 'Addresses',
    description: 'Routes | Account Addresses | Title',
  },
  addressesCustomDocumentTitle: {
    defaultMessage: 'Addresses | sweetgreen',
    description: 'Routes | Account Addresses | Custom Document Title',
  },
  ordersCustomDocumentTitle: {
    defaultMessage: 'Orders | sweetgreen',
    description: 'Routes | Account Orders | Custom Document Title',
  },
  favoritesTitle: {
    defaultMessage: 'Favorites',
    description: 'Routes | Account Favorites | Title',
  },
  favoritesCustomDocumentTitle: {
    defaultMessage: 'Favorites | sweetgreen',
    description: 'Routes | Account Favorites | Custom Document Title',
  },
  dietaryRestrictionsTitle: {
    defaultMessage: 'Dietary restrictions',
    description: 'Routes | Account Dietary Restrictions | Title',
  },
  dietaryRestrictionsCustomDocumentTitle: {
    defaultMessage: 'Dietary Restrictions | sweetgreen',
    description: 'Routes | Account Dietary Restrictions | Custom Document Title',
  },
  idMeTitle: {
    defaultMessage: 'Verify your ID.me account',
    description: 'Routes | Account ID.me | Title',
  },
  idMeCustomDocumentTitle: {
    defaultMessage: 'Verify your ID.me account | sweetgreen',
    description: 'Routes | Account ID.me | Custom Document Title',
  },
  notificationsTitle: {
    defaultMessage: 'Notifications',
    description: 'Routes | Account Notifications | Title',
  },
  notificationPreferencesCustomDocumentTitle: {
    defaultMessage: 'Notification Preferences | sweetgreen',
    description: 'Routes | Account Notification Preferences | Custom Document Title',
  },
});

// ─── Gift Cards Tab ──────────────────────────────────────────────────────────

const giftCardsTabRouteMessages = defineMessages({
  giftCardsTabTitle: {
    defaultMessage: 'Gift',
    description: 'Routes | Gift Cards | Title',
  },
  giftCardsTabCustomDocumentTitle: {
    defaultMessage: 'Gift Cards | sweetgreen',
    description: 'Routes | Gift Cards | Custom Document Title',
  },
  giftCardCheckoutTitle: {
    defaultMessage: 'Customize your gift',
    description: 'Routes | Gift Card Checkout | Title',
  },
  giftCardCheckoutCustomDocumentTitle: {
    defaultMessage: 'Customize your gift | Gift Card | sweetgreen',
    description: 'Routes | Gift Card Checkout | Custom Document Title',
  },
  giftCardConfirmationTitle: {
    defaultMessage: 'Order confirmation',
    description: 'Routes | Gift Card Confirmation | Title',
  },
  giftCardConfirmationCustomDocumentTitle: {
    defaultMessage: 'Order confirmation | Gift Card | sweetgreen',
    description: 'Routes | Gift Card Confirmation | Custom Document Title',
  },
  giftCardRedemptionCustomDocumentTitle: {
    defaultMessage: 'Redemption details | Gift Card | sweetgreen',
    description: 'Routes | Gift Card Redemption | Custom Document Title',
  },
});

// ─────────────────────────────────────────────────────────────────────────────

export const TITLES = {
  ...authRouteMessages,
  ...modalRouteMessages,
  ...homeTabRouteMessages,
  ...menuTabRouteMessages,
  ...loyaltyTabRouteMessages,
  ...reorderTabRouteMessages,
  ...accountTabRouteMessages,
  ...giftCardsTabRouteMessages,
};
